import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap';
import configAdmin from './admin/configAdmin.json';
import { getPageContent } from './admin/apiCalls';
import { store, StateProvider } from '../Store';
import LoadingSpinner from './LoadingSpinner';
import WavesBanner from './WavesBanner';

const { HOMEPAGE_CODE } = configAdmin

export default function Home() {  

  //const textContent = "En el marco del proyecto <strong>“Ciudades inclusivas, sostenibles e inteligentes como parte de la Agenda 2030 para el Desarrollo Sostenible en América Latina y el Caribe”</strong> el CELADE- División de Población de la CEPAL, implementó éste sitio con apoyo de la <em>Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH</em>, tendiente a mejorar y potenciar el uso de datos censales sobre desigualdad territorial y segregación residencial, migración interna y movilidad cotidiana para trabajar o estudiar de la población, para diagnósticos, políticas, programas, toma de decisiones, evaluaciones, investigación y usos de la comunidad en general, relativos a la gestión y planificación urbana y metropolitana en países y ciudades de la región." + "<br /><br /> En el presente sitio, los visitantes y usuarios podrán generar resultados e indicadores sobre los temas antes indicados a partir de microdatos censales disponibles para los países mencionados. Estos resultados e indicadores podrán visualizarse de manera rápida, precisa e interactiva, en tablas, gráficos y mapas. Esto aumentará la rapidez de los procesamientos, pues ya estarán habilitadas y estandarizadas las variables más complejas necesarias para ello. También expandirá la versatilidad y ductilidad de la manipulación de tablas (en particular de matrices de origen y destino) para producir indicadores novedosos y útiles. Asimismo, ofrecerá una visión espacial y cartográfica que permitirá situar los análisis a escala territorial de forma detallada y comunicativa. Y, finalmente, posibilitará el despliegue gráfico de datos, que siempre contribuye a la descripción e interpretación de los fenómenos estudiados.";

  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;
  
  const [textContent, setTextContent] = useState({});
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  useEffect(() => {
    getPageContent(setTextContent, HOMEPAGE_CODE);
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  const styleTheme = {
    'button': `${configData?.theme && configData.theme}-button`
  }

  /*
  const homePageContent = (
    <div className="odisea-page-home odisea-page-home-flex">
      <div className="odisea-page-home-content">
        <div dangerouslySetInnerHTML={{__html: textContent?.content && textContent.content}} />
      </div>
      <div className="odisea-page-home-links">
        <div className="odisea-page-home-links-title">
          Consulta los distintos módulos de { textContent?.title && textContent.title }
        </div>
        <div className="odisea-page-home-links-buttons">
          <Link to="/migration" className="">
            <Button variant="primary" className={"odisea-page-home-links-buttons-button " + styleTheme.button}>
              Migración
            </Button>
          </Link>
          <Link to="/mobility" className="">
            <Button variant="primary" className={"odisea-page-home-links-buttons-button " + styleTheme.button}>
              Movilidad
            </Button>
          </Link>
          <Link to="/segregation" className="">
            <Button variant="primary" className={"odisea-page-home-links-buttons-button " + styleTheme.button}>
              Segregación
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
  */
  const homePageContent = (
    <div className="odisea-page-home odisea-page-home-flex">
      <div className="odisea-page-home-links">
        <div className="odisea-page-home-links-title">
          Consulta los distintos módulos
        </div>
        <div className="odisea-page-home-links-buttons">
          <Link to="/migration" className="">
            <Button variant="primary" className={"odisea-page-home-links-buttons-button " + styleTheme.button}>
              Migración
            </Button>
          </Link>
          <Link to="/mobility" className="">
            <Button variant="primary" className={"odisea-page-home-links-buttons-button " + styleTheme.button}>
              Movilidad
            </Button>
          </Link>
          <Link to="/segregation" className="">
            <Button variant="primary" className={"odisea-page-home-links-buttons-button " + styleTheme.button}>
              Segregación
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )

  return (
    <>
      <WavesBanner />
      { Object.keys(textContent).length > 0 ? homePageContent : <LoadingSpinner /> }
    </>
  )

}
